import React from 'react';
import { Select } from 'antd';
import statesHash from '../../../helpers/stateHash';

const { Option } = Select;
const SelectUSState = ({ formType, initialValue, onChange }) => {
  const handleChange = (value) => {
    onChange(value);
  };

  return (
    <Select
      showSearch={true}
      defaultValue={initialValue || undefined}
      onChange={handleChange}
      allowClear
    >
      {Object.entries(statesHash).map(([key, value]) => (
        <Option key={key} value={key}>
          {value}
        </Option>
      ))}
    </Select>
  );
};

export default SelectUSState;
